export default __webpack_public_path__ + "static/media/Gilroy-Bold.26e59eb7.otf";